
const nameList = [
    {
        entityField: "planId",
        showField: "方案编码",
        fieldWeight: 130,
        fieldType: "string",

    },
    {
        entityField: "planName",
        showField: "方案名称",
        fieldWeight: 130,
        fieldType: "string",

    },
    {
        entityField: "planDesc",
        showField: "方案描述",
        fieldWeight: 130,
        fieldType: "string",

    },
    {
        entityField: "planType",
        showField: "促销类别",
        fieldWeight: 130,
        fieldType: "string",

    },
    {
        entityField: "state",
        showField: "方案状态",
        fieldWeight: 130,
        fieldType: "string",

    },
    // {
    //     entityField: "areaType",
    //     showField: "范围类别",
    //     fieldWeight: 100,
    //     fieldType: "string",

    // },
    // {
    //     entityField: "contentType",
    //     showField: "内容类别",
    //     fieldWeight: 100,
    //     fieldType: "string",

    // },
    {
        entityField: "startDate",
        showField: "开始日期",
        fieldWeight: 130,
        fieldType: "string",

    },
    {
        entityField: "endDate",
        showField: "结束日期",
        fieldWeight: 130,
        fieldType: "string",

    },
    {
        entityField: "dayStartTime",
        showField: "每日开始时间",
        fieldWeight: 130,
        fieldType: "string",

    },
    {
        entityField: "dayEndTime",
        showField: "每日结束时间",
        fieldWeight: 130,
        fieldType: "string",

    },
    // {
    //     entityField: "reqType",
    //     showField: "要求类别",
    //     fieldWeight: 130,
    //     fieldType: "string",

    // },
    {
        entityField: "weekStr",
        showField: "促销周期",
        fieldWeight: 130,
        fieldType: "string",

    },
    {
        entityField: "dayStr",
        showField: "促销日期",
        fieldWeight: 130,
        fieldType: "string",

    },
//    {
//         entityField: "roundDay",
//         showField: "周期",
//         fieldWeight: 130,
//         fieldType: "string",

//     },


]



const  searchList= [
   

    {
        showField: "方案名称",
        entityField: "planName",
        isShow: 1,
        fieldType: "string",
        searchId: null,
        formatterContent: null,
        isRift: null,
        riftField: null,
        setField: null,
        fieldWeight: 120,
    },

   
]






export {nameList,searchList}